module.exports = __webpack_public_path__ + "img/banner05.b5abedec.jpg";